import { useState, useEffect } from 'react'

import styles from './styles.module.scss'

import MainImage from './images/main-image.png'
import MainImageMobile from './images/main-image-mobile.png'

import Step1Icon from './images/step1.svg'
import Step2Icon from './images/step2.svg'
import Step3Icon from './images/step3.svg'
import { useTranslation } from 'utils/use-translation'

export default function CoinWalletHowToGet({ pageCurrency }) {
  const { t } = useTranslation()
  const [windowWidth, setWindowWidth] = useState<number>(0)

  useEffect(() => {
    if (window) {
      setWindowWidth(window.innerWidth)
    }
  }, [])

  return (
    <section className={styles.howToGet}>
      <div className={styles.howToGet__content}>
        <div className={styles.title}>
          <h1>{t('how_get_a')} {pageCurrency.ticker} {t('wallet')}</h1>
        </div>
        <ol className={styles.list}>
          <li className={styles.list__item}>
            <img src={Step1Icon} alt="first number image" />
            <p>{t('account_signup')}</p>
          </li>

          <hr />

          <li className={styles.list__item}>
            <img src={Step2Icon} alt="second number image" />
            <p>
              {t('add')} {pageCurrency.name} ({pageCurrency.ticker}) {t('to_your_wallet')}
            </p>
          </li>

          <hr />

          <li className={styles.list__item}>
            <img className={styles.bigIcon} src={Step3Icon} alt="third number image" />
            <p>{t('wallet_access')}</p>
          </li>
        </ol>
      </div>
      <img className={styles.howToGet__image} src={windowWidth > 765 ? MainImage : MainImageMobile} alt="phone image" />
    </section>
  )
}
